import { MUTE_MEETING_AUDIO } from 'actions/Types';
import { shouldHaveFeature } from '@studio/feature.flags';

const initialState = false;

function muteMeetingAudio(state = initialState, action) {
  if (
    action.type === MUTE_MEETING_AUDIO &&
    !shouldHaveFeature('studio.requirePresenterAuth')
  ) {
    return action.payload;
  }

  return state;
}

export default muteMeetingAudio;
